import { ChangeDetectorRef, Component, NgZone, OnInit, HostListener, ViewChild, ElementRef, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import {
   NgxFileDropEntry,
   FileSystemFileEntry,
   FileSystemDirectoryEntry,
} from 'ngx-file-drop';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SubmissionsService } from 'src/app/services/submissions.service';
import { getCurrentUser } from 'src/app/authModule/state/authentication.selectors';
import { Store } from '@ngrx/store';
import { UploadfileService } from '../upload-file/service/uploadfile.service';
import { first } from 'rxjs/operators';
import swal from 'sweetalert2';
import { Router, NavigationExtras } from '@angular/router';
import { FilePreviewComponent } from '../file-preview/file-preview.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import validator from 'validator';
import { Handle, SliderRange } from '../../../shared/components/custom-slider/custom-slider.component';

@Component({
   selector: 'app-input-text',
   templateUrl: './input-text.component.html',
   styleUrls: ['./input-text.component.scss'],
})
export class InputTextComponent implements OnInit {
   @Input() isOnPrecheck: boolean;
   @Input() isStudent: boolean;
   @Input() maxUploads: number = 10;
   @Input() remainingUploads?: number; // Optional input from parent
   @Input() maxPrecheckUploads = 10; // Default value
   @Input() isPrecheckLimitReached = false;
   filesProperties = [];
   uploadedFile: any;
   converted: any;
   allowToSubmitDocument: any;
   trial: any;
   allowedProducer: any;
   documentCredits: any;
   uploaded = 0;
   filesPreviewReady = true;
   filesPreviewBar = 0;
   languageSelected: boolean;
   isProcessingFiles = false; // Flag to prevent multiple simultaneous uploads

   separatorKeysCodes: number[] = [ENTER, COMMA];
   includeUrlsArray: string[] = [];
   excludeUrlsArray: string[] = [];
   riskLevels = [
      { label: 'High risk', class: 'high', from: 80, to: 100 },
      { label: 'Medium risk', class: 'medium', from: 20, to: 80 },
      { label: 'Low risk', class: 'low', from: 0, to: 20 }
   ];
   translatedLanguageEnabled = new FormControl(false); // Using FormControl for the toggle
   selectedTranslatedLanguages = new FormControl([], [Validators.maxLength(3)]);
   constructor(
      private submissionService: SubmissionsService,
      private toastrService: ToastrService,
      private spinnerService: NgxSpinnerService,
      private fb: FormBuilder,
      private store: Store,
      private fileUpload: UploadfileService,
      private router: Router,
      private dialog: MatDialog,
      private cdr: ChangeDetectorRef,
      public translate: TranslateService,
      private zone: NgZone

   ) { }

   assignmentId;
   fileToUpload: File = null;
   uploadForm;
   user$;
   user;
   disableField = false;
   /**
    * List of third party libraries to check for document.
    */
   thirdPartyLib: Array<any> = [
      {
         description: 'ScienceDirect',
         isChecked: false,
         information:
            'Searching ScienceDirect content may involve delays on checking your document.',
      },
      {
         description: 'Scopus',
         isChecked: false,
         information:
            'Searching Scopus metadata and abstracts may involve delays on checking your document.',
      },
      {
         description: 'CORE',
         isChecked: false,
         information:
            'Searching CORE content may involve delays on checking your document. ',
      },
      {
         description: 'IEEE',
         isChecked: false,
         information:
            'Searching IEEE metadata and abstracts may involve delays on checking your document.',
      },
      {
         description: 'arXiv.org',
         isChecked: false,
         information:
            'Searching arXiv metadata and abstracts may involve delays on checking your document.',
      },
      {
         description: 'Crossref',
         isChecked: false,
         information:
            'Searching Crossref metadata and abstracts may involve delays on checking your document.',
      },
      {
         description: 'Europeana',
         isChecked: false,
         information:
            'Searching Europeana metadata and abstracts may involve delays on checking your document.',
      },
      {
         description: 'CaseLaw Access Project',
         isChecked: false,
         information:
            'Searching CaseLaw content may involve delays on checking your document.',
      },
   ];
   thesisId;
   originalLanguage = 'en';
   translatedLanguage = 'es';
   previewKey;
   thirdPartyLibraries: any = this.thirdPartyLib;
   /**
    * Boolean value used to show/hide advanced options of the form.
    */
   advancedOptionsIndex: boolean = false;
   /**
    * Boolean value used to get user consent to archive the file.
    */
   archive: boolean = false;
   /**
    * Document citation style picked by user.
    */
   citationStyle: string = '';

   languages = [
      {
         text: 'English',
         value: 'en',
      },
      {
         text: 'Albanian',
         value: 'sq',
      },
      {
         text: 'German',
         value: 'de',
      },
      {
         text: 'Italian',
         value: 'it',
      },
      {
         text: 'French',
         value: 'fr',
      },
      {
         text: 'Spanish',
         value: 'es',
      },
      {
         text: 'Greek',
         value: 'el',
      },
      {
         text: 'Czech',
         value: 'cs',
      },
      {
         text: 'Turkish',
         value: 'tr',
      },
      {
         text: 'Slovak',
         value: 'sk',
      },
      {
         text: 'Lithuanian',
         value: 'lt',
      },
      {
         text: 'Latvian',
         value: 'lv',
      },
      {
         text: 'Polish',
         value: 'pl',
      },
      {
         text: 'Serbian',
         value: 'sr',
      },
      {
         text: 'Macedonian',
         value: 'mk',
      },
      {
         text: 'Portuguese',
         value: 'pt',
      },
      {
         text: 'Dutch',
         value: 'nl',
      },
      {
         text: 'Russian',
         value: 'ru',
      },
      {
         text: 'Bulgarian',
         value: 'bg',
      },
      {
         text: 'Hungarian',
         value: 'hu',
      },
      {
         text: 'Romanian',
         value: 'ro',
      },
      {
         text: 'Slovenian',
         value: 'sl',
      },
      {
         text: 'Swedish',
         value: 'sv',
      },
      {
         text: 'Finnish',
         value: 'fi',
      },
      {
         text: 'Croatian',
         value: 'hr',
      },
      {
         text: 'Bosnian',
         value: 'bs',
      },
      {
         text: 'Norwegian',
         value: 'no',
      },
      {
         text: 'Danish',
         value: 'da'
      },
      {
         text: 'Estonian',
         value: 'et'
      }
   ];

   precheck = false;
   enableArchive = false;

   // First slider configuration
   similarityHandles: Handle[] = [
      { value: 60, min: 40, max: 90 },  // Altered Text
      { value: 80, min: 60, max: 90 }   // Exact Match
   ];
   similarityDefaultValues = [];

   // Second slider configuration
   translationHandles: Handle[] = [
      { value: 50, min: 0, max: 50, hardMinimum: 50 },
      { value: 80, min: 50, max: 95 }
   ];
   translationDefaultValues = [];

   similarityRangeColors: SliderRange[] = [
      { color: '#BCBCBC', label: 'Below Threshold' },
      { color: '#7ABDFF', label: 'Altered Text' },
      { color: '#F386AB', label: 'Exact Match' }
   ];


   translationRangeColors: SliderRange[] = [
      { color: '#D9D9D9', label: '' },
      { color: '#BCBCBC', label: '' },
      { color: '#FED27C', label: 'Contextual Similarity' }
   ];

   isDragging = false;
   activeHandle: number | null = null;
   settings;
   @ViewChild('sliderTrack') sliderTrack: ElementRef;

   // Dropdown options for originality score display
   options = [
      { value: 'percentage', label: 'Percentage', icon: 'assets/images/icons/Percentage.png' },
      { value: 'risk_factor', label: 'Risk factor', icon: 'assets/images/icons/dashboard-speed.png' },
      { value: 'none', label: 'None', icon: 'assets/images/icons/x.png' }
   ];
   dropdownOpen = false;
   selectedOption = this.options[0].value;

   ngOnInit(): void {
      // Clear files data on init to prevent accumulation
      this.resetFileState();
      this.languages.sort((a, b) => a.text.localeCompare(b.text));

      this.checkPrecheckLimit();

      this.user$ = this.store.select(getCurrentUser).subscribe((data) => {
         console.log('data in input text component', data);
         if (data !== null && data != undefined) {
            this.user = data;
            if (this.user?.roleId !== 10) {
               if (this.user?.allowedLanguages !== null) {
                  this.disableField = true;
               }
            }
         } else {
            console.log('user not found in the store');
            // Get the user from the local storage
            this.user = JSON.parse(localStorage.getItem('user'));
            console.log('user from local storage', this.user);
            if (this.user?.roleId !== 10) {
               if (this.user?.allowedLanguages !== null) {
                  this.disableField = true;
               }
            }
         }
      });
      const currentUrl = this.router.url;
      if ((currentUrl.includes('precheck') || this.isOnPrecheck) && this.user?.roleId == 9) {
         this.precheck = true;
      } else {
         this.precheck = false;
      }

      const institutionSettings = JSON.parse(localStorage.getItem('user'))

      this.settings = institutionSettings?.Institution?.InstitutionSettings[0]

      console.log('settings', this.settings);

      this.archive = this.settings?.archiveDocuments


      if (this.settings.alteredTextSimilarityThreshold) {
         this.similarityHandles[0].value = this.settings.alteredTextSimilarityThreshold;
      }

      if (this.settings.exactMatchSimilarityThreshold) {
         this.similarityHandles[1].value = this.settings.exactMatchSimilarityThreshold;
      }

      if (this.settings.contextualSimilarityThreshold) {
         this.translationHandles[1].value = this.settings.contextualSimilarityThreshold;
      }

      this.similarityDefaultValues = [this.settings.alteredTextSimilarityThreshold || 40, this.settings.exactMatchSimilarityThreshold || 60];
      this.translationDefaultValues = [50, this.settings.contextualSimilarityThreshold || 80]

      // this.uploadForm.controls['contextualSimilaritiesThreshold'].setValue(settings?.thresholds.contextual_similarity || 0);

      this.uploadForm = this.fb.group({
         assignmentId: [],
         thesisId: [],
         documentTitle: [''],
         fullName: ['', [Validators.required]],
         dateOfUpload: ['', [Validators.required]],
         documentSize: [''],
         documentCredits: [''],
         documentLanguage: [''],
         documentTranslatedLanguage: this.selectedTranslatedLanguages,
         aiDetection: [false],
         metadataAnalysis: [true],
         stylometricsAnalysis: [false],
         thirdPartyLibs: this.fb.array(this.thirdPartyLib),
         sources: this.fb.group({
            includeSources: this.fb.array([]),
            excludeSources: this.fb.array([])
         }),
         contextualSimilarity: [true],
         enableThresholds: [false],
         alteredTextThreshold: [this.settings?.alteredTextSimilarityThreshold ?? 60],
         exactMatchThreshold: [this.settings?.exactMatchSimilarityThreshold ?? 80],
         contextualSimilaritiesThreshold: [this.settings?.contextualSimilarityThreshold ?? 80],
         originalityReportScoreDisplay: [this.options[0].value, Validators.required],
         riskLevels: [this.riskLevels],
      });

      // Update validator subscription to immediately validate initial values
      this.uploadForm.get('enableThresholds').valueChanges.subscribe(this.updateThresholdValidators.bind(this));

      // Call immediately to set initial validation state
      this.updateThresholdValidators(this.uploadForm.get('enableThresholds').value);

      this.cdr.detectChanges()


      this.translatedLanguageEnabled.valueChanges.subscribe((enabled) => {
         if (!enabled) {
            this.selectedTranslatedLanguages.setValue([]); // Reset selected languages if disabled
         } else {
            if (this.settings?.enableTranslatedLanguages && this.settings?.translatedLanguages) {
               this.selectedTranslatedLanguages.setValue(this.settings.translatedLanguages);
            }
         }
      });
   }

   // Extract validation logic to separate method
   private updateThresholdValidators(enabled: boolean) {
      const alteredControl = this.uploadForm.get('alteredTextThreshold');
      const exactControl = this.uploadForm.get('exactMatchThreshold');
      const contextualControl = this.uploadForm.get('contextualSimilaritiesThreshold');

      if (enabled) {
         alteredControl.setValidators([Validators.max(90), Validators.min(40)]);
         exactControl.setValidators([Validators.max(90), Validators.min(60)]);
         contextualControl.setValidators([Validators.max(95), Validators.min(50)]);
      } else {
         alteredControl.clearValidators();
         exactControl.clearValidators();
         contextualControl.clearValidators();
      }

      alteredControl.updateValueAndValidity({ emitEvent: false });
      exactControl.updateValueAndValidity({ emitEvent: false });
      contextualControl.updateValueAndValidity({ emitEvent: false });
   }

   isSelected(language: string): boolean {
      return this.selectedTranslatedLanguages.value.includes(language);
   }

   public files: NgxFileDropEntry[] = [];

   /**
    * Reset all file-related state to initial values
    * Used when clearing files or starting fresh uploads
    */
   private resetFileState(): void {
      this.filesProperties = [];
      this.uploaded = 0;
      this.filesPreviewReady = true;
      this.filesPreviewBar = 0;
      this.files = [];
      this.fileToUpload = null;
      this.isProcessingFiles = false;
   }

   /**
    * Public method to reset the upload component state
    * Can be called externally or when user wants to start fresh
    */
   public resetUpload(): void {
      this.resetFileState();
      // Reset form fields related to file upload
      if (this.uploadForm) {
         this.uploadForm.patchValue({
            documentTitle: '',
            documentSize: '',
            documentCredits: ''
         });
      }
   }

   public dropped(files: NgxFileDropEntry[]) {
      console.log('isStudent', this.isStudent);
      console.log('precheck', this.precheck);
      console.log('isOnPrecheck', this.isOnPrecheck);
      console.log('remainingUploads', this.remainingUploads);
      console.log('files.length', files.length);

      // Prevent multiple simultaneous uploads
      if (this.isProcessingFiles) {
         this.toastrService.warning('Please wait for the current upload to complete before uploading new files.');
         return;
      }

      // Check if user has reached precheck limit before processing files
      if ((this.precheck || this.isOnPrecheck) && (this.user?.roleId == 5 || this.user?.roleId == 9)) {
         if (this.remainingUploads !== undefined && files.length > this.remainingUploads) {
            this.toastrService.info(
               this.translate.instant('new_entries.upload_limit_exceeded', {
                  fileCount: files.length,
                  remainingUploads: this.remainingUploads,
                  filesToRemove: files.length - this.remainingUploads
               })
            );
            return;
         }
      }

      // Clear existing files before processing new uploads
      this.resetFileState();
      this.isProcessingFiles = true;

      this.files = files;
      this.uploaded = 1;
      let filesUploaded = 0;
      for (const droppedFile of files) {
         let fileProperties = {
            fileSize: '',
            title: '',
            previewSrc: '',
            converted: '',
            fileKey: '',
            allowedProducer: '',
         };
         // Is it a file?
         if (droppedFile.fileEntry.isFile) {
            const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
            fileEntry.file((file: File) => {
               fileProperties.title = file.name;
               this.fileToUpload = file;
               const firstName = this.user?.name.split(' ')[0];
               const lastName = this.user?.name.split(' ')[1];
               this.form.fullName.setValue(this.user?.name);
               let fileSize = this.formatBytes(this.fileToUpload.size);
               fileProperties.fileSize = fileSize;
               this.form.documentSize.setValue(fileSize);
               if (this.assignmentId || this.thesisId) {
                  this.form.documentLanguage.setValue(this.originalLanguage);
                  this.form.documentTranslatedLanguage.setValue(
                     this.translatedLanguage
                  );
               }
               let date = new Date();
               let filesFailed = 0;
               let dateString =
                  date.getDate() +
                  '/' +
                  (date.getMonth() + 1) +
                  '/' +
                  date.getFullYear();
               this.form.dateOfUpload.setValue(dateString);
               let type;

               if (!file.type) {
                  type = file.name.split('.')[file.name.split('.').length - 1];
               } else {
                  type = file.type;
               }

               // this.spinner.show();
               this.fileUpload
                  .generatePresignedURL(type, firstName, lastName)
                  .pipe(first())
                  .subscribe(
                     async (data) => {
                        if (data?.showAlert) {


                        } else {
                           this.previewKey = data.key;

                           this.fileUpload
                              .uploadfileAWSS3(data.presignedS3Url, file)
                              .pipe(first())
                              .subscribe(
                                 async (data1) => {
                                    this.fileUpload
                                       .generatePresignedURLPreview(
                                          data.key,
                                          type,
                                          firstName,
                                          lastName
                                       )
                                       .pipe(first())
                                       .subscribe((data) => {
                                          this.documentCredits =
                                             data.documentCredits;
                                          setTimeout(() => {
                                             fileProperties.previewSrc =
                                                data.presignedS3UrlPreview;
                                             fileProperties.converted =
                                                data.converted;
                                             fileProperties.fileKey = data.Key;
                                             fileProperties.allowedProducer =
                                                data.allowedProducer;

                                             this.filesProperties.push(
                                                fileProperties
                                             );
                                             this.filesPreviewBar =
                                                (this.filesProperties.length *
                                                   100) /
                                                files.length;

                                             this.allowToSubmitDocument =
                                                data.allowSubmission.allowToSubmitDocument;
                                             this.trial =
                                                data.allowSubmission.trail;

                                             this.form.documentCredits.setValue(
                                                this.documentCredits
                                             );
                                             if (
                                                this.user?.Institution !==
                                                null &&
                                                this.user?.roleId === 2
                                             ) {
                                                this.form.documentTranslatedLanguage.setValue(
                                                   this.user?.allowedLanguages
                                                      ?.targetLanguage
                                                );
                                                this.form.documentLanguage.setValue(
                                                   this.user?.allowedLanguages
                                                      ?.documentLanguage
                                                );
                                             } else {
                                                // this.form.documentTranslatedLanguage.setValue(
                                                //    -1
                                                // );
                                                // this.form.documentLanguage.setValue('');
                                             }
                                             if (
                                                this.assignmentId ||
                                                this.thesisId
                                             ) {
                                                this.form.documentLanguage.setValue(
                                                   this.originalLanguage
                                                );
                                                this.form.documentTranslatedLanguage.setValue(
                                                   this.translatedLanguage
                                                );
                                                this.form.documentLanguage.disable();
                                                this.form.documentTranslatedLanguage.disable();
                                             }

                                             filesUploaded++;
                                             if (
                                                files.length == filesUploaded
                                             ) {
                                                this.filesPreviewReady = true;
                                                this.isProcessingFiles = false;
                                                this.cdr.detectChanges();
                                             }
                                          }, 500);
                                       }),
                                       (error) => {


                                          filesUploaded++;


                                          if (files.length == filesUploaded) {
                                             this.filesPreviewReady = true;
                                             this.isProcessingFiles = false;
                                             this.cdr.detectChanges();
                                          }
                                          console.log('error3', error);
                                       };
                                 },
                                 (error) => {


                                    filesUploaded++;


                                    if (files.length == filesUploaded) {
                                       this.filesPreviewReady = true;
                                       this.isProcessingFiles = false;
                                       this.cdr.detectChanges();
                                    }
                                    console.log('error2', error);
                                 }
                              );
                        }
                     },
                     (error) => {
                        filesUploaded++;



                        if (files.length == filesUploaded) {
                           this.filesPreviewReady = true;
                           this.isProcessingFiles = false;
                           this.cdr.detectChanges();
                        }
                        console.log('error1', error);
                     }
                  );
            });

         } else {
            // It was a directory (empty directories are added, otherwise only files)
            const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
            console.log(droppedFile.relativePath, fileEntry);
         }
      }
   }

   addUrlOnEnter(event: KeyboardEvent, type: string): void {
      const inputElement = event.target as HTMLInputElement;
      const value = inputElement.value.trim();
      if (value) {
         if (validator.isURL(value, { require_protocol: false })) {
            const control = this.fb.control(value);

            if (type === 'include') {
               (this.form.sources.get('includeSources') as FormArray).push(control);
               this.includeUrlsArray.push(value);
            } else if (type === 'exclude') {
               (this.form.sources.get('excludeSources') as FormArray).push(control);
               this.excludeUrlsArray.push(value);
            }
         } else {
            this.toastrService.error(`Invalid URL: ${value}`);
         }
      }

      // Clear the input value after adding the URL
      inputElement.value = '';
   }


   removeUrl(index: number, type: string, event: MouseEvent): void {
      if (type === 'include') {
         (this.form.sources.get('includeSources') as FormArray).removeAt(index);
         this.includeUrlsArray.splice(index, 1);
      } else if (type === 'exclude') {
         (this.form.sources.get('excludeSources') as FormArray).removeAt(index);
         this.excludeUrlsArray.splice(index, 1);
      }
   }

   get form() {
      return this.uploadForm.controls;
   }

   public fileOver(event) {
      console.log(event);
   }

   public fileLeave(event) {
      console.log(event);
   }

   /**
    * Method used to create submission when uploading a document.
    */

   /**
    * Method used to create submission when uploading a document.
    */
   async createSubmission() {
      // Check if precheck limit is reached - only for students (roles 5 and 9), not educators (role 10)
      if ((this.precheck || this.isOnPrecheck) &&
         (this.user?.roleId == 5 || this.user?.roleId == 9) &&
         this.isPrecheckLimitReached) {
         this.toastrService.error(`You have reached the maximum limit of ${this.maxPrecheckUploads} precheck uploads allowed.`);
         return;
      }

      if (this.isOnPrecheck && this.remainingUploads <= 0 && (this.user?.roleId == 5 || this.user?.roleId == 9)) {
         this.toastrService.error('You have reached the maximum number of precheck uploads allowed. Please delete some existing submissions to continue.');
         return;
      }

      this.zone.run(async () => {

         this.cdr.detectChanges();


         this.spinnerService.show();


         for (let index = 0; index < this.filesProperties.length; index++) {
            const element = this.filesProperties[index];
            let withCredits = true;
            if (this.user?.institutionId !== null && this.user?.roleId == 2) {
               if (this.user?.documentsToUse > 0 && this.user?.wordsToUse > 0) {
                  const result = await swal.fire({
                     title: 'Choose how to proceed',
                     text: 'Would you like to use credits or  number of documents?',
                     icon: 'question',
                     cancelButtonText: 'Close',
                     confirmButtonText: 'With credits',
                     denyButtonText: 'With documents',
                     denyButtonColor: '#2455C2',
                     confirmButtonColor: '#F3001E',
                     cancelButtonColor: '#8F00F1',
                     showDenyButton: true,
                     showCancelButton: true,
                     allowOutsideClick: false,
                  });
                  if (result.isConfirmed) {
                     withCredits = true;
                  }
                  if (result.isDenied) {
                     withCredits = false;
                  }
                  if (result.isDismissed) {
                     return;
                  }
               } else {
                  if (this.user?.documentsToUse > 0 && this.user?.wordsToUse === 0) {
                     withCredits = false;
                  } else if (
                     this.user?.documentsToUse === 0 &&
                     this.user?.wordsToUse > 0
                  ) {
                     withCredits = true;
                  } else {
                     await swal.fire({
                        title: `Something is wrong!`,
                        text: `You don't have credits or documents to submit the document`,
                        icon: 'error',
                        confirmButtonText:
                           this.translate.instant('app.i_understand'),
                        confirmButtonColor: '#F3001E',
                        allowOutsideClick: false,
                     });
                     return;
                  }
               }
            }


            if (this.form.documentTranslatedLanguage.value === -1) {
               this.form.documentTranslatedLanguage.setValue(null);
            }

            if (!this.translatedLanguageEnabled.value) {
               this.form.documentTranslatedLanguage.setValue(null);
            }

            this.submissionService
               .createSubmission(
                  element.title,
                  element.fileKey,
                  this.form.fullName.value,
                  this.form.dateOfUpload.value,
                  element.fileSize,
                  this.form.documentLanguage.value,
                  this.form.documentTranslatedLanguage.value,
                  this.archive ? this.archive : false,
                  this.citationStyle,
                  this.thirdPartyLibraries,
                  element.converted,
                  withCredits,
                  this.form.assignmentId.value,
                  this.form.thesisId.value,
                  this.form.aiDetection.value,
                  this.form.sources.value,
                  this.form.contextualSimilarity.value,
                  this.form.enableThresholds.value,
                  this.form.exactMatchThreshold.value || 80,
                  this.form.alteredTextThreshold.value || 60,
                  this.form.contextualSimilaritiesThreshold.value || 80,
                  this.form.metadataAnalysis.value,
                  this.form.stylometricsAnalysis.value
               )
               .subscribe(
                  (data: any) => {
                     if (data.showAlert == true) {
                        this.trial = data.allowSubmission.trial;
                        setTimeout(() => {
                           if (this.isOnPrecheck) {
                              this.resetFileState(); // Reset file state before navigation
                              const navigationExtras: NavigationExtras = {
                                 queryParams: { refresh: new Date().getTime() }
                              };
                              this.router.navigate(['/precheck-external'], navigationExtras);
                           } else {
                              this.router.navigateByUrl('/individual/dashboard');
                           }
                        }, 1500);
                        if (index + 1 == this.filesProperties.length) {


                           this.toastrService.success(
                              this.translate.instant('new_entries.document_uploaded_successfully')
                           );
                        }
                     } else {


                        if (index + 1 == this.filesProperties.length) {


                           this.spinnerService.hide();
                           this.toastrService.success(
                              this.translate.instant('new_entries.document_uploaded_successfully')
                           );

                           // Reset file state after successful submission
                           this.resetFileState();

                           if (this.isOnPrecheck) {
                              const navigationExtras: NavigationExtras = {
                                 queryParams: { refresh: new Date().getTime() }
                              };
                              this.router.navigate(['/precheck-external'], navigationExtras);
                           } else {
                              if (
                                 this.user?.roleId !== 4 &&
                                 this.user?.roleId !== 5 &&
                                 this.user?.roleId !== 9 &&
                                 this.user?.roleId !== 10
                              ) {
                                 this.router.navigateByUrl('/individual/dashboard');
                              } else if (
                                 this.user?.roleId == 4 ||
                                 this.user?.roleId == 10
                              ) {
                                 this.router.navigateByUrl('/professor/submissions');
                              } else if (
                                 (this.user?.roleId == 5 ||
                                    this.user?.roleId == 9) && !this.precheck
                              ) {
                                 this.router.navigateByUrl('/student/register/upload');
                              } else if (
                                 (this.user?.roleId == 5 ||
                                    this.user?.roleId == 9) && this.precheck
                              ) {
                                 this.router.navigateByUrl('/student/pre-check');
                              }
                           }
                        }
                     }
                  },
                  (error) => {
                     console.log('error Submit', error);
                     if (withCredits) {
                        if (
                           error !==
                           'Document title must be at least 5 characters' &&
                           error !==
                           `Document title can't be more than 190 characters`
                        ) {
                           // this.showAlertMessage();
                        }
                     }
                     this.spinnerService.hide();

                     // Reset file state on error to prevent inconsistent state
                     if (index + 1 == this.filesProperties.length) {
                        this.resetFileState();
                     }


                  }
               );
         }

      });
   }

   selectTranslatedLanguage(event) {
      this.selectedTranslatedLanguages = event.value;
      this.form.documentTranslatedLanguage.setValue(this.selectedTranslatedLanguages);
   }

   formatBytes(bytes) {
      var marker = 1024; // Change to 1000 if required
      var decimal = 2; // Change as required
      var kiloBytes = marker; // One Kilobyte is 1024 bytes
      var megaBytes = marker * marker; // One MB is 1024 KB
      var gigaBytes = marker * marker * marker; // One GB is 1024 MB

      if (bytes < kiloBytes) return bytes + ' Bytes';
      else if (bytes < megaBytes)
         return (bytes / kiloBytes).toFixed(decimal) + ' KB';
      else if (bytes < gigaBytes)
         return (bytes / megaBytes).toFixed(decimal) + ' MB';
   }

   /**
    * Method to display modal that the producer is not allowed
    */
   async showNotAllowedProducerMessage() {
      const result = await swal.fire({
         title: this.translate.instant('app.this_file_has_some_issues'),
         text: this.translate.instant(
            'app.try_converting_your_file_to_docx_and_then_convert_it_to_pdf'
         ),
         icon: 'warning',
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#b5adad',
         confirmButtonText: this.translate.instant('app.i_understand'),
         allowOutsideClick: false,
      });
   }

   /**
    * Method used to inform user that he can't upload document.
    */
   async showAlertMessage() {
      if (this.user?.roleId != 4 && this.user?.roleId !== 5) {
         let title = `Not enough credits!`;
         let message = `To submit your document you need ${Math.abs(
            this.user?.wordsToUse - this.documentCredits
         )} more credits.`;
         const result = await swal.fire({
            title: title,
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b5adad',
            confirmButtonText: 'Buy more credits',
            allowOutsideClick: false,
         });
         if (result.isConfirmed) {
            this.router.navigateByUrl('/individual/add-credits');
         } else if (result.isDismissed) {
            this.router.navigateByUrl('/individual/dashboard');
         }
      }
   }

   previewFile(src) {
      console.log(src, 'srcc');

      this.dialog.open(FilePreviewComponent, {
         width: '50%',
         height: '90%',
         data: {
            src,
         },
      });
   }

   deleteFile(index) {
      this.filesProperties.splice(index, 1);
      if (this.filesProperties.length == 0) {
         this.resetFileState();
      }
   }

   showFormMessages() {
      if (this.form.documentLanguage.invalid) {
         this.showWarningMessage('Please select a language!');
      } else if (!this.filesPreviewReady) {
         this.showWarningMessage('Please wait for files preview');
      }
   }

   showWarningMessage(message) {
      this.toastrService.warning(message);
   }

   selectLanguage(event) {
      if (event == '-1') {
         this.showWarningMessage('Please select a language!');
         this.form.documentLanguage.setErrors({
            required: true,
            invalid: true,
            touched: true,
         });
         this.languageSelected = true;
      } else {
         this.languageSelected = false;
         this.form.documentLanguage.setValue(event);
      }
   }

   advancedOptions() {
      if (this.advancedOptionsIndex == false) {
         this.advancedOptionsIndex = true;
      } else {
         this.advancedOptionsIndex = false;
      }
   }

   archiveDocument() {
      this.archive = !this.archive;
   }

   onPaste(event: ClipboardEvent, type: string) {
      const pastedUrl = event.clipboardData.getData('text').trim();
      const inputElement = event.target as HTMLInputElement;

      if (validator.isURL(pastedUrl, { require_protocol: false })) {
         const control = this.fb.control(pastedUrl);
         if (type === 'include') {
            (this.form.sources.get('includeSources') as FormArray).push(control);
            this.includeUrlsArray.push(pastedUrl);
         } else if (type === 'exclude') {
            (this.form.sources.get('excludeSources') as FormArray).push(control);
            this.excludeUrlsArray.push(pastedUrl);
         }
         inputElement.value = '';
      } else {
         this.toastrService.error(`Invalid URL: ${pastedUrl}`);
         inputElement.value = '';
      }
   }

   ngAfterViewInit() {
      this.updateTrackColors();
   }

   private updateTrackColors() {
      const track = document.querySelector('.slider-track') as HTMLElement;
      if (!track) return;

      requestAnimationFrame(() => {
         // Ensure we have valid values
         const alteredStart = this.similarityHandles[0]?.value ?? 0;
         const exactStart = this.similarityHandles[1]?.value ?? 100;

         // Update the CSS variables
         track.style.setProperty('--altered-start', `${alteredStart}%`);
         track.style.setProperty('--exact-start', `${exactStart}%`);
      });
   }

   @HostListener('window:mousemove', ['$event'])
   onMouseMove(event: MouseEvent) {
      if (this.isDragging && this.activeHandle !== null) {
         const sliderRect = (event.target as HTMLElement)
            .closest('.slider-wrapper')
            ?.getBoundingClientRect();

         if (sliderRect) {
            const percentage = Math.min(Math.max(
               ((event.clientX - sliderRect.left) / sliderRect.width) * 100,
               0
            ), 100);

            const roundedPercentage = Math.round(percentage);

            switch (this.activeHandle) {
               case 0: // Altered Text
                  const maxAltered = Math.min(this.similarityHandles[1].value - 1, this.similarityHandles[0].max);
                  this.similarityHandles[0].value = Math.min(Math.max(roundedPercentage, this.similarityHandles[0].min), maxAltered);
                  // Update form value
                  this.uploadForm.patchValue({
                     alteredTextThreshold: this.similarityHandles[0].value
                  });
                  break;

               case 1: // Exact Match
                  const minExact = Math.max(this.similarityHandles[0].value + 1, this.similarityHandles[1].min);
                  this.similarityHandles[1].value = Math.min(Math.max(roundedPercentage, minExact), this.similarityHandles[1].max);
                  // Update form value
                  this.uploadForm.patchValue({
                     exactMatchThreshold: this.similarityHandles[1].value
                  });
                  break;
            }

            this.updateHandleConstraints();
            this.updateTrackColors();
            this.cdr.detectChanges();
         }
      }
   }

   @HostListener('window:mouseup')
   onMouseUp() {
      this.isDragging = false;
      this.activeHandle = null;
   }

   startDragging(event: MouseEvent, index: number) {
      this.isDragging = true;
      this.activeHandle = index;
      event.preventDefault();

      // Update form values based on which handle is being dragged
      if (index === 0) {
         this.uploadForm.patchValue({
            alteredTextThreshold: this.similarityHandles[0].value
         });
      } else if (index === 1) {
         this.uploadForm.patchValue({
            exactMatchThreshold: this.similarityHandles[1].value
         });
      }
   }

   private updateHandleConstraints() {
      // Update Altered Text constraints
      this.similarityHandles[0].max = this.similarityHandles[1].value - 1;

      // Update Exact Match constraints
      this.similarityHandles[1].min = this.similarityHandles[0].value + 1;
   }

   @HostListener('click', ['$event'])
   onSliderClick(event: MouseEvent) {
      const target = event.target as HTMLElement;
      const sliderWrapper = target.closest('.slider-wrapper');

      if (sliderWrapper && !target.classList.contains('slider-handle')) {
         const sliderRect = sliderWrapper.getBoundingClientRect();
         const percentage = Math.min(Math.max(
            ((event.clientX - sliderRect.left) / sliderRect.width) * 100,
            0
         ), 100);

         const roundedPercentage = Math.round(percentage);

         // Find the closest handle
         const distanceToAltered = Math.abs(this.similarityHandles[0].value - roundedPercentage);
         const distanceToExact = Math.abs(this.similarityHandles[1].value - roundedPercentage);

         if (distanceToAltered <= distanceToExact) {
            // Move Altered Text handle
            const maxAltered = Math.min(this.similarityHandles[1].value - 1, this.similarityHandles[0].max);
            this.similarityHandles[0].value = Math.min(Math.max(roundedPercentage, this.similarityHandles[0].min), maxAltered);
         } else {
            // Move Exact Match handle
            const minExact = Math.max(this.similarityHandles[0].value + 1, this.similarityHandles[1].min);
            this.similarityHandles[1].value = Math.min(Math.max(roundedPercentage, minExact), this.similarityHandles[1].max);
         }

         this.updateHandleConstraints();
         this.updateTrackColors();
         this.cdr.detectChanges();

         // Update form values after determining which handle moved
         this.uploadForm.patchValue({
            alteredTextThreshold: this.similarityHandles[0].value,
            exactMatchThreshold: this.similarityHandles[1].value
         });
      }
   }

   onSimilarityHandleChange(handles: Handle[]) {
      this.similarityHandles = [...handles];

      // Update form values when sliders change
      this.uploadForm.patchValue({
         alteredTextThreshold: handles[0].value,
         exactMatchThreshold: handles[1].value
      });

      this.updateTrackColors();
      this.cdr.detectChanges();
   }

   onTranslationHandleChange(handles: Handle[]) {
      this.translationHandles = [...handles];

      // Update form value when translation slider changes
      this.uploadForm.patchValue({
         contextualSimilaritiesThreshold: handles[1].value
      });

      this.cdr.detectChanges();
   }

   openLink(url: string) {
      window.open(url, '_blank');
   }

   /**
    * Handle keyboard events for accessibility
    * @param event KeyboardEvent
    */
   @HostListener('keydown', ['$event'])
   handleKeyboardNavigation(event: KeyboardEvent): void {
      // Handle keyboard navigation for the file upload area
      if (event.target && (event.target as HTMLElement).classList.contains('contentOnFileDrop')) {
         if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            // Simulate click on the file upload area
            const fileDropElement = event.target as HTMLElement;
            fileDropElement.click();
         }
      }
   }

   // Update the checkPrecheckLimit method
   private checkPrecheckLimit(): void {
      const currentUrl = this.router.url;
      const isPrecheckPage = currentUrl.includes('precheck') || this.isOnPrecheck;
      if (!this.user) {
         this.user = JSON.parse(localStorage.getItem('user'));
      }

      // Only apply precheck limits for students (roles 5 and 9), not for educators (role 10)
      if (isPrecheckPage && this.user && (this.user.roleId == 5 || this.user.roleId == 9)) {
         if (this.user.Institution?.InstitutionSettings[0]) {
            this.maxPrecheckUploads = this.user.Institution.InstitutionSettings[0].studentSubmissionPrecheckLimit || 10;
         }

         if (this.remainingUploads === undefined) {
            this.fetchPrecheckSubmissionsCount();
         } else {
            this.isPrecheckLimitReached = this.remainingUploads <= 0;
         }
      } else if (isPrecheckPage && this.user && this.user.roleId == 10) {
         // For educators, set unlimited uploads (no limit check)
         this.isPrecheckLimitReached = false;
      }
   }

   // Update the fetchPrecheckSubmissionsCount method
   private fetchPrecheckSubmissionsCount(): void {
      // Only fetch count for students (roles 5 and 9)
      if (this.user.roleId == 5 || this.user.roleId == 9) {
         this.submissionService.getAssignmentStudentSubmissions(1, null, true)
            .subscribe(
               (response: any) => {
                  const totalSubmissions = response.totalSubmissions ||
                     response.totalStudentSubmissions ||
                     (response.studentSubmissions?.length || 0);
                  // Calculate remaining uploads
                  const remainingUploads = Math.max(0, this.maxPrecheckUploads - totalSubmissions);
                  this.remainingUploads = remainingUploads;
                  this.isPrecheckLimitReached = remainingUploads <= 0;
               },
               (error) => {
                  console.error('Error fetching precheck submissions count:', error);
                  // Assume there are still uploads available if we can't verify
                  this.isPrecheckLimitReached = false;
               }
            );
      } else if (this.user.roleId == 10) {
         // For educators, no limit applies
         this.isPrecheckLimitReached = false;
      }
   }

   toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
   }

   selectOption(value: string) {
      this.uploadForm.get('originalityReportScoreDisplay').setValue(value);
      this.selectedOption = value;
      this.dropdownOpen = false;
   }

   getIconPath(value: string): string {
      const option = this.options.find(opt => opt.value === value);
      return option ? option.icon : '';
   }

   getLabel(value: string): string {
      const option = this.options.find(opt => opt.value === value);
      return option ? option.label : '';
   }

   onRiskLevelsChange(updated: any[]) {
      this.uploadForm.get('riskLevels').setValue(updated);
   }
}
